import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


const __default__ = {
  name: 'AvatarGroup'
}

import { NAvatar, NAvatarGroup } from 'naive-ui'
import { computed } from 'vue'
import useTeamMember from '@teams/common/hooks/useTeamMember'
import useTeamShare from '@teams/common/hooks/useTeamShare'

import { useGroupStore } from '@/store/group'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    handleTrigger: null,
    max: null
  },
  setup(__props: any) {



const { current } = useGroupStore()
const { memberList } = useTeamMember()

const { inviteInfo, hasInviteInfo } = useTeamShare()
const members = computed(() => {
  // 私密空间,邀请链接访问
  if (!current.id && hasInviteInfo) {
    return inviteInfo.value.group_users || []
  }
  return memberList.value
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NAvatarGroup), {
    options: _unref(members),
    size: 24,
    max: __props.max,
    class: "member-trigger",
    onClick: __props.handleTrigger
  }, {
    avatar: _withCtx(({ option: { avatar } }) => [
      _createVNode(_unref(NAvatar), { src: avatar }, null, 8, ["src"])
    ]),
    rest: _withCtx(({}) => [
      _createVNode(_unref(NAvatar), { class: "member-count" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(current).memberCount), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["options", "max", "onClick"]))
}
}

})